import UploadOutlined from '@ant-design/icons/UploadOutlined';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import Model from 'antd/lib/modal';
import Upload from 'antd/lib/upload';
import React, { useContext, useState } from 'react';

import { axiosPostCall } from '../../api/axiosCall';
import { API_END_POINT, SOMETHING_WENT_WRONG } from '../../constant/constants';
import { AuthContext } from '../../context/AuthProvider';
import { uploadFile, S3ImageFolder } from '../../utils/imageUploader';

function AddCategoryModel({ isOpen, handleModelClose, callback }) {
  const [addForm] = Form.useForm();
  const { token } = useContext(AuthContext);

  const [fileList, setFileList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    handleModelClose();
    setFileList([]);
    addForm.resetFields();
  };

  async function addProductCategory({ fileURL }) {
    try {
      const res = await axiosPostCall({
        apiEndPoint: API_END_POINT.ADD_PRODUCT_CATEGORY,
        header: {
          Authorization: `Bearer ${token}`,
        },
        body: {
          categoryName: addForm.getFieldValue().name,
          categoryImagePath: fileURL,
        },
      });
      if (res?.hideErrorFromUser) {
        message.success(res.data.message);
        callback();
        handleClose();
        setIsLoading(false);
        return;
      } else {
        message.error(res?.error?.message);
        setIsLoading(false);
      }
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
      setIsLoading(false);
    }
  }

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  async function handleAddCategory() {
    try {
      setIsLoading(true);
      const list = [];
      for (const file of fileList) {
        const data = await uploadFile(
          file,
          S3ImageFolder.ProductCategory,
          token,
        );
        list.push(data);
      }
      await addProductCategory({ fileURL: list[0] });
    } catch (error) {
      console.error('uploadFile', error);
      setIsLoading(false);
      return false;
    }
  }

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      if (fileList.length < 1) {
        setFileList([...fileList, file]);
      } else {
        message.error('Max image upload limit reached');
      }
      return false;
    },
    fileList,
  };

  return (
    <div>
      <Model
        open={isOpen}
        onCancel={handleClose}
        closable={false}
        footer={null}
      >
        <div className='flex flex-col space-y-4'>
          <div className='font-bold text-2xl'>Add Category</div>
          <Form form={addForm}>
            <Form.Item
              label='Category Name'
              name='name'
            >
              <Input name='categoryName' />
            </Form.Item>
            <Form.Item
              label='Upload'
              valuePropName='fileList'
              getValueFromEvent={normFile}
            >
              <Upload
                accept='image/*'
                {...uploadProps}
                multiple={false}
                maxCount={1}
              >
                <Button
                  type='dashed'
                  icon={<UploadOutlined />}
                  className='border-primary text-primary'
                >
                  Click to Upload
                </Button>
              </Upload>
            </Form.Item>
          </Form>
          <div className='flex flex-row justify-around'>
            <Button
              onClick={handleModelClose}
              className='w-28 bg-surface border border-border text-text hover:text-primary hover:border-primary'
            >
              Close
            </Button>
            <Button
              onClick={handleAddCategory}
              disabled={isLoading}
              type='primary'
              className='w-32 border-none bg-gradient-to-r from-blue-500 to-purple-600 shadow hover:shadow-md'
            >
              {isLoading ? 'Adding...' : 'Add'}
            </Button>
          </div>
        </div>
      </Model>
    </div>
  );
}

export default AddCategoryModel;
